import { Component, OnDestroy } from '@angular/core';
import { BreadcrumbService } from './app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem, Message } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { FAZILService, User, UserService } from './core';
import { PerfilService } from './perfil/perfil.service';
import { UIService } from './core/services/ui.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InvoiceGlobal } from './modelo/InvoiceGlobal';
import { ComprobantesService } from './services/comprobantes.service';
import { AdministracionService } from './administracion/administracion.service';
import { UsuarioModel } from './modelo/usuario.model';
import { UserData } from './modelo/user.data';
import { Establishment } from './modelo/Establishment';
import { EmissionPoint } from './modelo/EmissionPoint';
import { EstablecimientosService } from './perfil/establecimientos/establecimientos.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    styleUrls: ['./app.breadcrumb.component.scss']
})
export class AppBreadcrumbComponent implements OnDestroy {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    subscription: Subscription;
    title: string;
    items: MenuItem[];

    ambientes: any[] = [];
    ambiente: any;

    ui: UIService;

    //Sección de ayuda
    safeSrc: SafeResourceUrl;
    display: boolean;
    displayqr: boolean;
    pageDescription: string;
    textHelp: string;
    
    invoiceGlobal: InvoiceGlobal = new InvoiceGlobal();
    
    mapaAyuda: any =  [
        { title: "Contactos/Clientes", 
            url: "https://prod.facturafacilecuador.com/assets/pdf/ayuda/Creacion%20de%20Clientes%20FacturaFacilEcuador%20v01.pdf", 
            ayuda: "En esta sección usted podrá crear sus Contactos o clientes, es decir las personas o empresas a quienes les va a facturar." 
        },
        { title: "Factura", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_nueva_factura.pdf.pdf", 
            ayuda: "En esta opción usted puede realizar la emisión de una nueva factura para un cliente." 
        },
        { title: "Facturas Emitidas", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_listado.pdf", 
            ayuda: "En esta opción usted podrá crear nuevas facturas para sus clientes, además de visualizar las facturas que fueron emitidas con éxito o tuvieron alguna observación por parte del SRI." 
        },
        { title: "Facturas Recibidas", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_recibida.pdf", 
            ayuda: "Aquí se listarán las facturas que otros proveedores le hayan enviado a usted de manera automática, exclusívamente utilizando el sistema de FacturaFácil Ecuador. (En caso de que las facturas fueran generadas en otro sistema o plataforma, las facturas no se mostrarán en esta sección)." 
        },
        { title: "Nota de Crédito", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_listado.pdf", 
            ayuda: "En esta opción usted puede realizar la emisión de una nueva nota de crédito para un cliente." 
        },
        { title: "Notas de Crédito Recibidas", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_factura_recibida.pdf", 
            ayuda: "Aquí se listarán las notas de crédito que otros proveedores le hayan enviado a usted de manera automática, exclusívamente utilizando el sistema de FacturaFácil Ecuador. (En caso de que las notas de crédito fueran generadas en otro sistema o plataforma, las notas de crédito no se mostrarán en esta sección)."
        },
        { title: "Registro/Actualización de firma electrónica", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_carga_firma.pdf", 
            ayuda: "En caso de ya contar con su firma electrónica, por favor cárguela en el sistema en esta sección. La Firma y la correspondiente clave, se almacenan de manera encriptada dentro del sistema, por lo que únicamente podrá ser utilizada en el sistema de Facturación electrónica."
        },
        { title: "Servicios/Productos", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_producto.pdf", 
            ayuda: "En esta sección usted podrá crear sus Productos o Servicios, estos corresponden a los productos o servicios que se van a facturar."
        },
        { title: "Detalle de RUC", 
            url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_info_sri.pdf", 
            ayuda: "En esta opción usted debe registrar la información base necesaria para la emisión de las facturas."
        },
    ];
    
    mostrarAyuda = true;
    
    //Variables para establecimientos
    mostrarSeleccionarEstablecimiento:boolean = false;
    establishments: Establishment[] = [];
    establishment: Establishment;
    emissionPointSelected: EmissionPoint;

    constructor(
        public breadcrumbService: BreadcrumbService,
        private userService: UserService,
        private perfilService: PerfilService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private comprobantesService: ComprobantesService,
        private establecimientosService: EstablecimientosService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;

        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
            let length = this.items.length;
            this.title = this.items[length - 1]['label'];
            this.pageDescription = this.items[length - 1]['tooltip'];
            this.textHelp = this.items[length - 1]['fragment'];
            const ayuda = this.buscarAyuda(this.title);
            this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(ayuda.url);
            this.pageDescription = ayuda.ayuda;
        });
    }

    ngOnInit(): void {
        this.ambientes = this.appConfig.properties.ambientes;
        this.userService.currentUser.subscribe(
            (userData) => {
                this.currentUser = userData;
                this.mostrarAyuda = !this.currentUser.ocultarAyuda;
                if (this.currentUser.organization && this.currentUser.organization.ambienteSRI && this.ambientes && this.ambientes.length) {
                    this.ambiente = this.ambientes.find((item) => item.value == this.currentUser.organization.ambienteSRI) ? this.ambientes.find((item) => item.value == this.currentUser.organization.ambienteSRI)['value'] : null;
                    this.establishments = this.currentUser.organization.establecimientos;
                    this.cargarDataInit();
                }
            }
        );
        
        this.userService.establishment.subscribe(
            (data) => {
                if (Object.keys(data).length === 0){
                    this.establishment = this.establishments[0];
                } else {
                    this.establishment = data;
                }
            }
        );
        this.userService.emissionPoint.subscribe(
            (data) => {
                if (Object.keys(data).length === 0){
                    this.emissionPointSelected = this.establishment.emissionPoints[0];
                } else {
                    this.emissionPointSelected = data;
                }
            }
        );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    
    async cargarDataInit() {

        if ( this.establishment && this.emissionPointSelected ){
        //Obtener detalles de cantidad de comprobantes contratados vs emitidos
            this.invoiceGlobal = await this.comprobantesService.getComprobantesEnviadasRecibidasPorUsuarioConectadoFiltrarData('', this.establishment.name, this.emissionPointSelected.name, null, new Date(), new Date());
            this.invoiceGlobal.mostrarAlertaRecarga = this.invoiceGlobal.numeroComprobantesPorEmitir < this.invoiceGlobal.minimoComprobantesAlertarRecarga;
        }
    }

    actualizarAmbiente(event) {
        this.ui.limpiarMessages();
        if (event && event.option) {
            if (this.currentUser.organization && this.currentUser.organization) {
                this.currentUser.organization.ambientePro = (event.option['value'] == 'PRODUCCION');
                this.perfilService.enviarOrganization(this.currentUser.organization).subscribe(
                    (data) => {
                        this.ui.mostrarMensaje("info", "Actualización del ambiente SRI de la Organización " + this.currentUser.organization.initials + " a " + event.option['name'] + ".");
                        this.userService.populate(); //Forzar la carga de los nuevos datos
                    },
                    (err) => {
                        this.ui.mostrarError(err);
                    }
                );
            } else {
                this.ui.mostrarMensaje("error", "No fue posible actualizar el ambiente SRI para " + this.currentUser.nombre);
            }
        }
    }
    
    
    ocultarAyuda(mostrar:boolean){
        this.ui.limpiarMessages();
        this.mostrarAyuda = mostrar;
        if ( this.currentUser ) {
            this.currentUser.ocultarAyuda = mostrar;
            const user: User = {} as User;
            Object.assign(user, this.currentUser);
            //TODO enviar solo lo necesario para actualizar
            user.organization = null; //remover organizacion
            user.assistant = null;//remover assistant
            user.token = null;//remover token
            this.userService.update(user).subscribe(
                (data) => {                    
                    //const response:User = data['user'];
                    this.userService.populate(); //Forzar la carga de los nuevos datos
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }
    
    
    buscarAyuda(title:string):any {
        let ayuda =  this.mapaAyuda.find( a => a.title == title );
        if (!ayuda){
            ayuda = {title: "Ayuda general", url: "https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_contacto.pdf", ayuda:"Ingrese los datos solicitados y presione los botones correspondientes a la acción que necesita"};
        }
        return ayuda;
    }
    
    /**
     ** Métodos de formulario
     **/
     recargarPlan($event) {
        this.fazilService.irALanding();
    }
    
    async activarPopupSeleccionarEstablecimiento(event) {
        this.mostrarSeleccionarEstablecimiento = true;
    }
    
    asignarPuntoEmision(pem:EmissionPoint){
        
        const estab: Establishment = this.establishments.find((item) => item.id == pem.establishmentId);
        if (estab) {
            this.userService.setEstablishmentSubject(estab);
            this.userService.setEmissionPointSubject(pem);
        }
    }

}
